import { useState, useCallback } from "react";
import MyModal from "../../../Common/my-modal/my-modal.component";
import styles from "./index.module.scss";
import ModalForm from "./modal-form";
import { IAddMemberFormValues } from "../../../../common/validations/members-access.validations";

interface AddMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddMemberModal = ({ isOpen, onClose }: AddMemberModalProps) => {
  const [formValues, setFormValues] = useState<IAddMemberFormValues | null>(null);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  const handleFormStateChange = useCallback(
    (values: IAddMemberFormValues, isValid: boolean) => {
      setFormValues(values);
      setIsFormValid(isValid);
    },
    []
  );

  const handleApply = async () => {
   
  };

  return (
    <MyModal show={isOpen} onHide={onClose} className={styles.modal}>
      <MyModal.Header
        closeButton
        onCrossClick={onClose}
        className="border-bottom"
      >
        <MyModal.HeaderTitle className="text-align-center w-100">
          New Member
        </MyModal.HeaderTitle>
      </MyModal.Header>
      <MyModal.Body className={styles.modalBody}>
        <ModalForm onFormStateChange={handleFormStateChange} />
      </MyModal.Body>
      <MyModal.Footer className="d-flex gap-4 border-top">
        <MyModal.CancelButton onClick={onClose}>Cancel</MyModal.CancelButton>
        <MyModal.ApplyButton onClick={handleApply} disabled={!isFormValid}>
          Create
        </MyModal.ApplyButton>
      </MyModal.Footer>
    </MyModal>
  );
};

export default AddMemberModal;
